import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 102	剧情分歧结束类
 */

export default class EventTextEnd extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }

  /**
   * 事件ID
   */
  Code = EventID.TextEnd
  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
